import request from '../../utils/request';

// API intake ledger (Aug 2026) — the raw JSON bodies partners POSTed to
// ovo-api's /v2/partner-orders, forwarded here for debugging + replay.
export function getIntakes(params) {
  return request('/partner-intake', { method: 'GET', params });
}

// Full row including the raw JSONB body (the list omits it — bodies can be
// hundreds of KB, so they load lazily on row expand).
export function getIntake(id) {
  return request(`/partner-intake/${id}`, { method: 'GET' });
}

// Replay a stored body against ovo-api. `asPartnerCode` overrides the partner
// identity — resending a BUT body as BUT_TEST routes it to the DEV planner.
export function resendIntake(id, asPartnerCode) {
  return request(`/partner-intake/${id}/resend`, {
    method: 'POST',
    data: asPartnerCode ? { asPartnerCode } : {},
  });
}

// OVO-292 — open refusals: upload items the planner SKIPPED / REJECTED whose
// external id still has no live order (closes itself once the order exists).
export function getIntakeRefusals(params) {
  return request('/partner-intake/refusals', { method: 'GET', params });
}

export function getIntakeRefusalCount() {
  return request('/partner-intake/refusals/count', { method: 'GET' });
}
